import { render, staticRenderFns } from "./BuyCreditsButton.vue?vue&type=template&id=955dfb72&scoped=true&"
import script from "./BuyCreditsButton.vue?vue&type=script&lang=js&"
export * from "./BuyCreditsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955dfb72",
  null
  
)

export default component.exports